<template>
  <section>
    <ValidationProvider
      v-if="hasValidator"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors, valid }">
        <b-field
          v-bind="$attrs"
          :type="{ 'is-danger': errors[0], 'is-success': valid }"
          :message="errors">
            <b-taginput
                v-model="selected"
                :data="filterHorses"
                autocomplete
                :open-on-focus="true"
                field="name"
                type="is-primary"
                :maxtags="1"
                :has-counter="false"
                icon="label"
                placeholder="Selecciona un Caballo"
                @typing="horse = $event" :loading="isLoading">
                <template slot-scope="props">
                  <span>{{props.option.name}}</span>
                  <b-icon
                    v-if="props.option.rider_id === riderId"
                    icon="star">
                  </b-icon>
                </template>
            </b-taginput>
        </b-field>
    </ValidationProvider>
    <b-taginput
      v-else-if="type === 'tag'"
      v-model="selected"
      :data="filterHorses"
      autocomplete
      :open-on-focus="true"
      field="name"
      type="is-primary"
      :maxtags="1"
      :has-counter="false"
      icon="label"
      placeholder="Selecciona un Caballo"
      @typing="horse = $event" :loading="isLoading">
        <template slot-scope="props">{{props.option.name}}</template>
    </b-taginput>
    <b-autocomplete
        v-else-if="type === 'autocomplete'"
        v-model="horse"
        placeholder="Selecciona un Caballo"
        :open-on-focus="true"
        :data="filterHorses"
        field="name"
        @select="option => selected = option" :loading="isLoading" ref='search'>
        <template #header v-if="hasCreateParentModal">
            <a @click="addParentModal">
              <span> Añadir uno nuevo </span>
            </a>
        </template>
        <template slot-scope="props">
          {{props.option.name}}
        </template>
        <template slot="empty">Sin Caballos</template>
    </b-autocomplete>
    <horse-parent-form :gender="genderType" :active.sync="modalCreateParent" @saved="createdHorseParent"/>
  </section>
</template>

<script>
import HorseService from '@/services/HorseService'
import HorseParentForm from '@/views/horses/components/HorseParentForm'
const Diacritics = require('diacritic')

export default {
  components: { HorseParentForm },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    hasValidator: {
      type: Boolean,
      default: false
    },
    riderId: {
      required: false,
      default: null,
      type: Number
    },
    value: {
      required: false,
      default: null,
      type: Number
    },
    type: {
      type: String,
      default: 'tag'
    },
    params: {
      type: Object,
      default: null
    },
    values: {
      required: false,
      default: () => [],
      type: Array
    },
    empty: {
      required: false,
      default: null,
      type: Boolean
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    hasCreateParentModal: {
      default: false,
      type: Boolean
    }
  },
  created () {
    this.getHorses()
  },
  data () {
    return {
      horse: '',
      selected: null,
      horses: [],
      isLoading: false,
      modalCreateParent: false
    }
  },
  methods: {
    async getHorses () {
      this.isLoading = true

      if (this.values.length > 0 || this.empty) {
        this.horses = this.values
      } else {
        let response
        if (this.hasCreateParentModal) {
          response = await HorseService.getParentHorses(this.params)
        } else {
          response = await HorseService.getHorses(this.params)
        }
        this.horses = response.data.data
      }

      if (this.riderId) {
        this.horses = this.horses.sort((a, b) => {
          if (this.riderId === a.rider_id) {
            return -1
          } else {
            if (a.name > b.name) {
              return 1
            }
            if (a.name < b.name) {
              return -1
            }
            return 0
          }
        })
      }

      if (this.hasValidator && this.value) {
        this.selected = this.horses.filter((x) => x.id === this.value)
      } else if (this.value) {
        this.selected = this.horses.filter((x) => x.id === this.value)[0]
        this.horse = this.selected ? `${this.selected.name}` : ''
      }
      if (this.autofocus) {
        setTimeout(() => {
          if (this.$refs.search) {
            this.$refs.search.focus()
          }
        }, 500)
      }
      this.isLoading = false
    },
    addParentModal () {
      this.modalCreateParent = true
    },
    createdHorseParent (horse) {
      if (horse) {
        this.horses.push(horse)
        this.horse = horse.name
        this.selected = horse
      }
    }
  },
  computed: {
    filterHorses () {
      let fixedHorses = Array.from(this.horses)
      fixedHorses.forEach((horse) => {
        horse.fixed = Diacritics.clean(horse.name)
      })

      return fixedHorses.filter((horse) => {
        return `${horse.fixed}`
          .toString()
          .toLowerCase()
          .indexOf(Diacritics.clean(this.horse.toLowerCase())) >= 0
      })
    },
    genderType () {
      return this.params && this.params.gender ? this.params.gender : null
    }
  },
  watch: {
    selected () {
      if (this.type === 'autocomplete') {
        this.$emit('select', this.selected)
      } else {
        this.$emit('select', this.selected[0])
      }
    },
    riderId () {
      this.getHorses()
    },
    value () {
      if (!this.hasValidator && this.selected && this.selected.id !== this.value && !this.isLoading) {
        this.selected = this.horses.filter((x) => x.id === this.value)[0]
      } else if (this.selected && this.selected.id !== this.value && !this.isLoading) {
        this.selected = this.horses.filter((x) => x.id === this.value)
      }
    },
    values () {
      this.getHorses()
    }
  }
}
</script>

<style>
  .taginput .taginput-container .autocomplete input {
    height: 1.7em !important;
  }
  .taginput .taginput-container .autocomplete .icon {
    height: 1.7em !important;
  }
</style>
